import React from 'react';

const AsSection = ({
  stats,
  asFilterPeriod,
  setAsFilterPeriod,
  asFilterDate,
  setAsFilterDate
}) => {
  const style = {
    grid3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '25px', marginBottom: '30px' },
    grid2: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '25px' },
    card: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    kpiCard: { padding: '25px', borderRadius: '15px', color: 'white', display: 'flex', flexDirection: 'column', minHeight: '130px', justifyContent: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    kpiTitle: { fontSize: '13px', fontWeight: '700', opacity: 0.85, marginBottom: '10px', letterSpacing: '0.5px' },
    kpiValue: { fontSize: '26px', fontWeight: 'bold' },
    tabButton: (isActive) => ({
      padding: '10px 22px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold',
      background: isActive ? '#1e293b' : 'transparent',
      color: isActive ? 'white' : '#64748b',
      transition: 'all 0.2s'
    }),
    input: { padding: '10px 15px', border: '1px solid #cbd5e1', borderRadius: '8px', outline: 'none', fontSize: '14px', background: 'white' },
    innerFlexBetween: { display: 'flex', justifyContent: 'space-between', padding: '16px 12px', borderBottom: '1px solid #f1f5f9', fontSize: '14px', alignItems: 'center' },
    badge: (bg, text) => ({ background: bg, color: text, padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' }),
    chartBarContainer: { background: '#f1f5f9', width: '100%', height: '16px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' },
    chartBarFill: (color, width) => ({ background: color, width: `${width}%`, height: '100%', transition: 'width 0.5s ease-in-out' })
  };

  return (
    <>
      <div style={style.grid3}>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #2563eb, #1d4ed8)'}}>
          <div style={style.kpiTitle}>🛠️ 실시간 정비 건수 (선택 조건내)</div>
          <div style={style.kpiValue}>{(stats.totalAsCount !== undefined ? stats.totalAsCount : 0)} 건</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #16a34a, #15803d)'}}>
          <div style={style.kpiTitle}>🟢 수리 수납 완결 마감 건수</div>
          <div style={style.kpiValue}>{(stats.asStatus.completed || 0)} 건 완료</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #ea580c, #c2410c)'}}>
          <div style={style.kpiTitle}>⏳ 대기 및 진행 중인 현장 공정</div>
          <div style={style.kpiValue}>{((stats.asStatus.receipt || 0) + (stats.asStatus.progressing || 0))} 건 대기</div>
        </div>
      </div>

      <div style={{...style.card, padding:'20px 30px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <span style={{fontWeight:'bold', fontSize:'15px', color:'#1e293b'}}>📌 AS 정밀 분석 범위 제어 (월간/연간 구분)</span>
        <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
          <button style={style.tabButton(asFilterPeriod==='전체')} onClick={()=>setAsFilterPeriod('전체')}>전체 누적</button>
          <button style={style.tabButton(asFilterPeriod==='월간')} onClick={()=>setAsFilterPeriod('월간')}>월간 분석</button>
          <button style={style.tabButton(asFilterPeriod==='연간')} onClick={()=>setAsFilterPeriod('연간')}>연간 분석</button>
          
          {asFilterPeriod !== '전체' && (
            <input 
              type={asFilterPeriod==='월간'?'month':'number'} 
              style={style.input} 
              placeholder={asFilterPeriod==='연간'?'연도 입력 (예: 2026)':''}
              value={asFilterPeriod==='연간'? asFilterDate.substring(0,4) : asFilterDate}
              onChange={e=>setAsFilterDate(e.target.value.length===4? `${e.target.value}-01-01` : e.target.value)}
            />
          )}
        </div>
      </div>
      
      <div style={style.grid2}>
        <div style={style.card}>
          <h4 style={{margin: '0 0 15px 0', color: '#334155'}}>📊 정비 공정 및 매출 구조 스크리닝</h4>
          <div style={{display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px'}}>
            <div style={{...style.innerFlexBetween, background: '#f8fafc', borderRadius: '10px'}}>
              <span>⏳ 현재 미완료 및 정비 접수 상태 (대기)</span>
              <span style={{fontWeight: 'bold', color: '#ea580c'}}>{stats.asStatus.receipt} 건</span>
            </div>
            <div style={{...style.innerFlexBetween, background: '#f8fafc', borderRadius: '10px'}}>
              <span>🔵 수리 완료 / 대금 미지불 (미수금 관리)</span>
              <span style={{fontWeight: 'bold', color: '#2563eb'}}>{stats.asStatus.progressing} 건</span>
            </div>
            <div style={{...style.innerFlexBetween, background: '#f8fafc', borderRadius: '10px'}}>
              <span>🟢 최종 수리 수납 및 결제 완료 상태</span>
              <span style={{fontWeight: 'bold', color: '#16a34a'}}>{stats.asStatus.completed} 건</span>
            </div>
            <div style={{...style.innerFlexBetween, background: '#f8fafc', borderRadius: '10px'}}>
              <span>🟡 정비 보류 및 피드백 대기 상태</span>
              <span style={{fontWeight: 'bold', color: '#ca8a04'}}>{stats.asStatus.pending} 건</span>
            </div>
          </div>
        </div>

        <div style={style.card}>
          <h4 style={{margin: '0 0 15px 0', color: '#334155'}}>🔥 빈발 발생 입고 증상 Top 5 (R&D 피드백)</h4>
          <p style={{margin: '0 0 20px 0', fontSize: '12px', color: '#64748b'}}>포톤 툰랜드 유통 및 LSV 기술 피드백용 누적 데이터 추적 차트</p>
          <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
            {stats.topSymptoms.map((item, index) => (
              <div key={index}>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                  <span><b style={{color: '#ef4444'}}>{index + 1}위</b> {item.name} <span style={{color: '#94a3b8'}}>({item.count}건)</span></span>
                  <span style={{fontWeight: 'bold'}}>{item.percentage}%</span>
                </div>
                <div style={{...style.chartBarContainer, height: '8px', marginTop: '4px'}}>
                  <div style={style.chartBarFill('#ef4444', item.percentage)}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AsSection;